export default class FloatyText extends createjs.Text {
    constructor(text, font, color) {
        super(text, font, color);

        this.initialize();
    }

    initialize() {
        const amplitude = 4;
        this._originY = this.y;
        this.y = this.y + amplitude;

        createjs.Tween
            .get(this, { loop: true })
            .to({ y: this._originY - amplitude }, 1050, createjs.Ease.quadInOut)
            .to({ y: this._originY + amplitude }, 1050, createjs.Ease.quadInOut);
    }
}